import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const PromoBanner = () => {
  return (
    <section className="px-6 md:px-10 py-12 md:py-16 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div
          className="relative w-full rounded-3xl overflow-hidden bg-cover bg-center min-h-[360px] md:min-h-[440px] flex items-center"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1540574163026-643ea20ade25?w=1920&q=80')",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />
          <div className="relative z-10 px-8 md:px-16 py-12 max-w-2xl">
            <p className="text-white/80 text-xs md:text-sm tracking-[0.3em] uppercase mb-4">
              Limited Time · Factory Outlet
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6 font-display-serif tracking-tight leading-tight">
              Save up to 40% on bedroom collections
            </h2>
            <p className="text-white/90 text-base md:text-lg mb-8 leading-relaxed">
              Complete bedroom suites — beds, mattresses, wardrobes and tallboys — priced direct from the factory floor.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/furniture#bed"
                className="inline-flex items-center gap-2 bg-white text-black px-7 py-3.5 rounded-full text-sm font-medium hover:bg-gray-100 btn-transition"
              >
                Shop Bedroom
                <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
              </Link>
              <a
                href="tel:+61411418088"
                className="inline-flex items-center gap-2 border-2 border-white text-white px-7 py-3.5 rounded-full text-sm font-medium hover:bg-white hover:text-black btn-transition"
              >
                Call (02) 97872567
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoBanner;
